// ToastContext.js
import React, { createContext, useContext } from 'react';
import { toast } from 'react-toastify';

// Create the context
const ToastContext = createContext();

// Create a custom hook to access the toast function
export const useToastContext = () => useContext(ToastContext);

// Create the provider component
export const ToastProvider = ({ children }) => {
  // You can modify or add more methods to the 'toast' object if needed
  const toastFunctions = {
    toast,
  };

  return (
    <ToastContext.Provider value={toastFunctions}>{children}</ToastContext.Provider>
  );
};
